import React from 'react';
import ReactGA from 'react-ga';

export default () => (
  <div className="About">
    <div className="title">
      About Me
    </div>
    <div className="content">
      PhD in International Relations <br />
      Stockholm Universtiy
    </div>
    <div className="content">
      For more inquiries, please contact me:&nbsp;
      <ReactGA.OutboundLink
        eventLabel="Email Link"
        to="mailto:ece.kural@ekohist.su.se"
        target="_blank"
      >
        ece.kural@ekohist.su.se
      </ReactGA.OutboundLink>
    </div>
    <div className="subtitle">
      Social Media
    </div>
    <div className="content">
      <i className="fa fa-linkedin" style={{ width: 30, color: '#007bb6' }} />
      <ReactGA.OutboundLink
        eventLabel="About Page Linkedin Link"
        to="https://www.linkedin.com/in/ece-kural/"
        target="_blank"
      >
        LinkedIn
      </ReactGA.OutboundLink>
      <br />
      <i className="fa fa-medium" style={{ width: 30, color: '#00ab6c' }} />
      <ReactGA.OutboundLink
        eventLabel="About Page Medium Link"
        to="https://medium.com/@EceThinks"
        target="_blank"
      >
        Medium
      </ReactGA.OutboundLink>
      <br />
      <i className="fa fa-twitter" style={{ width: 30, color: '#0084b4' }} />
      <ReactGA.OutboundLink
        eventLabel="About Page Twitter Link"
        to="https://twitter.com/EceThinks"
        target="_blank"
      >
        Twitter
      </ReactGA.OutboundLink>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/about/View.js